// Accessor for the Sentry browser SDK, which is loaded via the CDN Loader
// Script (see SentryLoader in the root layout), NOT bundled. Importing
// `@sentry/nextjs` here — even dynamically — pulled the whole SDK barrel
// (~385KB incl. Replay/Feedback) into First-Load JS. The loader installs a
// buffering `window.Sentry` stub that queues capture calls until the full SDK
// lazy-loads, so these fire-and-forget calls are safe even before it's ready.
// If the loader isn't present (DSN unset, or before the stub installs), this is
// a no-op — acceptable, since client Sentry is a bonus.

// Minimal shape of the loader's global Sentry — only what the logger calls.
interface LoaderSentry {
  captureException: (exception: unknown, captureContext?: Record<string, unknown>) => void
  captureMessage: (message: string, captureContext?: Record<string, unknown>) => void
}

const getSentry = (): LoaderSentry | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }
  return (window as unknown as { Sentry?: LoaderSentry }).Sentry
}

export const sentryCall = (fn: (sentry: LoaderSentry) => void): void => {
  const sentry = getSentry()
  if (sentry) {
    fn(sentry)
  }
}
